import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SidebarLogo from "../../Image/Everyday -Logo.png";
import { Collapse } from "antd";
import "./SideBar.css";
import { faCircle } from '@fortawesome/free-regular-svg-icons';

import { faBarsStaggered, faHouse , faTrophy, faMoneyBill1Wave, faMoneyBill, faGifts, faBoxes, faCogs, faBullhorn, faUser, faUserCircle, faWallet, faFileInvoiceDollar, faBarChart, faChartBar} from '@fortawesome/free-solid-svg-icons';
import { decryptData } from "../../controllers/Encryption";
import {
  getRandomColor,
  createImageFromInitials,
} from "../../controllers/common";
import { ASSETS_BASE_URL } from "../../config/constants";

const { Panel } = Collapse;

const SidebarItem = ({ to, icon, name, isOpen, className }) => (
  <NavLink to={to} className={`link ${className}`} activeClassName="active">
    <div className="icon">{icon}</div>
    <div style={{ display: isOpen ? "block" : "none" }} className="link_text">
      {name}
    </div>
  </NavLink>
);

const Sidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();
  const handleCollapseToggle = () => {
    setIsOpen(!isOpen);
  };
  const user = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));
  const [USERDATA, setUserData] = useState(user || "");

  
  const [PERMISSIONDATA, setPermissionData] = useState('');

  const handlePermission = async () =>{
    if(user && user.admin_type !== 'Super Admin'){
      const encrypted  = JSON.parse(sessionStorage.getItem("ADMIN-PERMISSION"));
      const decrypted  = await decryptData(encrypted);
      const permission = JSON.parse(decrypted);
      setPermissionData(permission);
    }
  }

  useEffect(()=>{
    if(sessionStorage.getItem("ADMIN-PERMISSION") !== 'undefined'){
      handlePermission();
    }
  },[])
  return (
    <div
      className={`container-fluid side_bar_main_div ${
        isOpen ? "sidebar-open" : "sidebar-closed"
      }`}
    >
      <div
        style={{ width: isOpen ? "300px" : "70px", position: "relative " }}
        className="sidebar"
      >
        <div className="top_section">
          <img
            src={SidebarLogo}
            className="sidebar_logo"
            alt="Logo"
            style={{
              marginLeft:"20px",
              display: isOpen ? "block" : "none",
              // height: "50px",
              width: "60%",
            }}
          />
          <div
            style={{ marginLeft: isOpen ? "50px" : "0px" }}
            className="bars"
          >
            <FontAwesomeIcon icon={faBarsStaggered} onClick={handleCollapseToggle} />
         
          </div>
        </div>
        <div className="my_sidebar_all_section">
          <SidebarItem
            to="/dashboard"
            icon={<FontAwesomeIcon icon={faHouse} />}
            name="Dashboard"
            isOpen={isOpen}
          />
          {(user?.admin_type === 'Super Admin') && (
            <React.Fragment>
              <Collapse accordion className="my_collapse_icon">
                <Panel
                  header={
                    <React.Fragment>
                         <FontAwesomeIcon icon={faUser} className="sidebar_collapse_iohomeoutline" />
                    
                      <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Accounts </span>
                    </React.Fragment>
                  }
                  key="categories"
                  className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                >
                  {user?.admin_type === 'Super Admin' &&(
                    <SidebarItem to="/sub-admin/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Sub Admin" isOpen={isOpen} />
                  )}
                </Panel>
              </Collapse>
            </React.Fragment>
          )}
          
          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.usersPermission?.list === 'Y'
          ) && (
            <React.Fragment>
              <Collapse accordion className="my_collapse_icon">
                <Panel
                  header={
                    <React.Fragment>
                      <FontAwesomeIcon icon={faUserCircle} className="sidebar_collapse_iohomeoutline" />
                      <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Users </span>
                    </React.Fragment>
                  }
                  key="categories"
                  className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                >
                  <SidebarItem to="/users/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                  {/* <SidebarItem to="/users/B2B-user-list"   icon={<FontAwesomeIcon icon={faCircle} />} name="B2B" isOpen={isOpen} /> */}
                  {/* <SidebarItem to="/users/B2C-user-list"   icon={<FontAwesomeIcon icon={faCircle} />} name="B2C" isOpen={isOpen} /> */}
                </Panel>
              </Collapse>
            </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.rechargePoints?.list === 'Y'
          ) && (
            <React.Fragment>
              <Collapse accordion className="my_collapse_icon">
                <Panel
                  key="categories"
                  className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                  header={
                    <React.Fragment>
                      <FontAwesomeIcon icon={faMoneyBill} className="sidebar_collapse_iohomeoutline" />
                      <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Recharge </span>
                    </React.Fragment>
                  }
                >
                  <SidebarItem to="/recharge/b-point-list"   icon={<FontAwesomeIcon icon={faCircle} />} name="B-Point" isOpen={isOpen} />
                </Panel>
              </Collapse>
            </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.promoCodes?.list === 'Y' ||
            PERMISSIONDATA?.promoCodesOrder?.list === 'Y' ||
            PERMISSIONDATA?.promoCodesVoucher?.list === 'Y' 
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon icon={faGifts} className="sidebar_collapse_iohomeoutline" />
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Promo Codes </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.promoCodes?.list === 'Y'
                ) &&(
                  <SidebarItem to="/promocodes/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.promoCodesOrder?.list === 'Y'
                ) &&(
                  <SidebarItem to="/promocodes/order"   icon={<FontAwesomeIcon icon={faCircle} />} name="Order" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.promoCodesVoucher?.list === 'Y'
                ) &&(
                  <SidebarItem to="/promocodes/vouchers/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Vouchers" isOpen={isOpen} />
                )}

              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.products?.list === 'Y' ||
            PERMISSIONDATA?.productVariant?.list === 'Y' ||
            PERMISSIONDATA?.productInventory?.list === 'Y' ||
            PERMISSIONDATA?.productOrder?.list === 'Y' 
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                        <FontAwesomeIcon icon={faBoxes} className="sidebar_collapse_iohomeoutline" />
                  
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Products </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.products?.list === 'Y'
                ) &&(
                  <SidebarItem to="/product/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.productVariant?.list === 'Y'
                ) &&(
                  <SidebarItem to="/product/variants/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Variants" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.productInventory?.list === 'Y'
                ) &&(
                  <SidebarItem to="/product/inventory/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Inventory" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.productOrder?.list
                ) &&(
                  <SidebarItem to="/product/order/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Orders" isOpen={isOpen} />
                )}
              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.generalDataCMS?.edit === 'Y' ||
            PERMISSIONDATA?.bannerCMS?.list === 'Y' 
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon icon={faCogs} className="sidebar_collapse_iohomeoutline" />
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> CMS </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.generalDataCMS?.edit === 'Y'
                ) &&(
                  <SidebarItem to="/cms/general_data/addeditdata"   icon={<FontAwesomeIcon icon={faCircle} />} name="General Data" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.bannerCMS?.list === 'Y' 
                ) &&(
                  <SidebarItem to="/cms/banner/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Banner" isOpen={isOpen} />
                )}
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.pickupPoint?.list === 'Y' 
                ) &&(
                  <SidebarItem to="/cms/pickup-point/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Pickup Points" isOpen={isOpen} />
                )}
              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.campaign?.list === 'Y' ||
            PERMISSIONDATA?.campaignOrder?.list === 'Y' ||
            PERMISSIONDATA?.campaignFreezes?.edit === 'Y' 
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon icon={faBullhorn} className="sidebar_collapse_iohomeoutline" />
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Campaign </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.campaign?.list === 'Y'
                ) &&(
                  <SidebarItem to="/campaign/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.campaignOrder?.list === 'Y'
                ) &&(
                  <SidebarItem to="/campaign/order/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Order" isOpen={isOpen} />
                )}
                 {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.campaignFreezes?.edit === 'Y'
                ) &&(
                  <SidebarItem to="/campaign/freezes"   icon={<FontAwesomeIcon icon={faCircle} />} name="Freezes" isOpen={isOpen} />
                )}
              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.raffleWinner?.list === 'Y'
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon icon={faTrophy} className="sidebar_collapse_iohomeoutline" />
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Raffle Winners </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.raffleWinner?.list === 'Y'
                ) &&(
                  <SidebarItem to="/raffle-winners/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                )}
              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.raffleDraw?.list === 'Y'
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                        <FontAwesomeIcon icon={faTrophy} className="sidebar_collapse_iohomeoutline" />
                  
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Raffle Draw </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.raffleDraw?.list === 'Y'
                ) &&(
                  <SidebarItem to="/raffle-draw/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                )}
              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.lottoWinner?.list === 'Y' ||
            PERMISSIONDATA?.lottoRedeem?.list === 'Y' ||
            PERMISSIONDATA?.lottoWinner?.analyser === 'Y'
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                        <FontAwesomeIcon icon={faMoneyBill1Wave} className="sidebar_collapse_iohomeoutline" />
                  
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Lotto Winners </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.lottoWinner?.list === 'Y'
                ) &&(
                  <SidebarItem to="/lotto-winners/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.lottoRedeem?.list === 'Y'
                ) &&(
                  <SidebarItem to="/lotto-winners/redeem-list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Redeem List" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.lottoWinner?.analyser === 'Y'
                ) &&(
                  <SidebarItem to="/lotto-winners/analyser"   icon={<FontAwesomeIcon icon={faCircle} />} name="Analyser" isOpen={isOpen} />
                )}

              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.walletStatement?.list === 'Y'
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                        <FontAwesomeIcon icon={faWallet} className="sidebar_collapse_iohomeoutline" />
                  
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Wallets Statement </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.walletStatement?.list === 'Y'
                ) &&(
                  <SidebarItem to="/wallets-statement/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="List" isOpen={isOpen} />
                )}
              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.individualInvoice?.list === 'Y' ||
            PERMISSIONDATA?.bulkInvoice?.list === 'Y' 
          ) && (
          <React.Fragment>
            <Collapse accordion className="my_collapse_icon">
              <Panel
                header={
                  <React.Fragment>
                    <FontAwesomeIcon icon={faFileInvoiceDollar} className="sidebar_collapse_iohomeoutline" />
                    <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Invoice </span>
                  </React.Fragment>
                }
                key="categories"
                className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
              >
                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.individualInvoice?.list === 'Y'
                ) &&(
                  <SidebarItem to="/invoice/list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Individual" isOpen={isOpen} />
                )}

                {(
                  user?.admin_type === 'Super Admin' ||
                  PERMISSIONDATA?.bulkInvoice?.list === 'Y'
                ) &&(
                  <SidebarItem to="/invoice/bulk-list"   icon={<FontAwesomeIcon icon={faCircle} />} name="Bulk" isOpen={isOpen} />
                )}
              </Panel>
            </Collapse>
          </React.Fragment>
          )}

          {(
            user?.admin_type === 'Super Admin' ||
            PERMISSIONDATA?.statisticsReport?.lotto === 'Y' ||
            PERMISSIONDATA?.statisticsReport?.voucher === 'Y' ||
            PERMISSIONDATA?.statisticsReport?.products === 'Y' ||
            PERMISSIONDATA?.statisticsReport?.lotto_redeem === 'Y' 
          ) && (
            <React.Fragment>
              <Collapse accordion className="my_collapse_icon">
                <Panel
                  header={
                    <React.Fragment>
                      <FontAwesomeIcon icon={faChartBar} className="sidebar_collapse_iohomeoutline" />
                      <span className={`sidebar_collapse_iohomeoutline_categoires ${isOpen ? "visible" : "hidden"}`}> Statistics </span>
                    </React.Fragment>
                  }
                  key="categories"
                  className={`side_bar_categories ${isOpen ? "arrow-visible" : "arrow-hidden"}`}
                >
                  <SidebarItem to="/statistics-reports"   icon={<FontAwesomeIcon icon={faCircle} />} name="Reports" isOpen={isOpen} />
                </Panel>
              </Collapse>
            </React.Fragment> 
          )}
          

          <React.Fragment>
            <SidebarItem
              icon={
                <img
                  // src={
                  //   user?.admin_image
                  //     ? ASSETS_BASE_URL + user.admin_image
                  //     : uWinnLogo
                  // }
                  src={SidebarLogo}
                  alt="profile-img"
                  className="user_profile_pic_sidebar"
                  onClick={handleCollapseToggle}
                  width="100px"
                />
              }
              to='javaScript:void(0)'
              name={
                <div className="sidebar_profile_main_content_section" onClick={()=>navigate("/sub-admin/addeditdata", { state: user })} >
                  <React.Fragment>
                    <div className="sidebar_profile_main_content">
                      <div className="user_profile_pic_Admin_name">
                        <span className="user_profile_pic_Admin_panel">
                          {`${user?.admin_first_name} ${user?.admin_last_name}`}
                        </span>{" "}
                        <br />
                        <span className="user_profile_pic_Admin_panel_">
                          Version :  1.0.0
                        </span>
                      </div>
                    </div>
                  </React.Fragment>
                  <React.Fragment>
                  <FontAwesomeIcon icon="fa-regular fa-greater-than"    className="side_bar_fagreaterthan"
                      onClick={handleCollapseToggle} />
                  </React.Fragment>
                </div>
              }
              isOpen={isOpen}
              className="custom_profile_class_productList"
            >
            </SidebarItem>
          </React.Fragment>
         
        </div>
      </div>
      <main>{children}</main>
    </div>
  );
};

export default Sidebar;
